import { useEffect, useRef } from 'react';
import Titol from 'components/3catinfo/Titol';
import Text from 'components/3catinfo/Text';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './embed.module.scss';

export default function Embed(props) {
    const { data, titol, tag = 'h2', entradeta, className, estil, mostraTitol = false, mostraEntradeta = false } = props;
    const htmlRoot = useRef();

    const styleEmbed = clsx({
        [styles.richtext]: true,
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    useEffect(() => {
        htmlRoot.current.innerHTML = '';
        const range = document.createRange();
        const documentFragment = range.createContextualFragment(data);
        htmlRoot.current.append(documentFragment);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <div className={styles.embed}>
            {mostraTitol && titol && (
                <div className={styles.infoTitol}>
                    <Titol titol={titol} tag={tag} className={styles.titol} />
                    {mostraEntradeta && entradeta && <Text className={styles.entradeta} text={entradeta} tag='div' />}
                </div>
            )}
            <div className={styleEmbed} ref={htmlRoot} />
        </div>
    );
}
